<template>
  <div class="uploader">
    <div class="container">
      <!--UPLOAD-->
      <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
        <h3 v-if="!hideTitle" v-translate>Upload file</h3>
        <div class="dropbox" :class="warning ? 'warning' : ''">
          <input type="file" :multiple="multiple" :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
            :accept="accept" class="input-file" :required="required">
            <p v-if="isInitial">
              <translate v-if="multiple">Drag your file(s) here to begin</translate>
              <translate v-else>Drag your file here to begin</translate>
              <br>
              <translate>or click to browse</translate>
            </p>
            <p v-if="isSaving" v-translate="{count: fileCount}">
              Uploading %{count} files...
            </p>
        </div>
      </form>
      <!--SUCCESS-->
      <div v-if="isSuccess">
        <h2 v-if="multiple" v-translate="{qty: uploadedFiles.length}">Uploaded %{qty} file(s) successfully.</h2>
        <h2 v-else v-translate>Uploaded 1 file successfully.</h2>
        <p>
          <a href="javascript:void(0)" @click="reset()" v-translate>Upload again</a>
        </p>
      </div>
      <!--FAILED-->
      <div v-if="isFailed">
        <h2 v-translate>Uploaded failed.</h2>
        <p>
          <a href="javascript:void(0)" @click="reset()" v-translate>Try again</a>
        </p>
        <pre>{{ uploadError }}</pre>
      </div>
    </div>
  </div>
</template>

<script>

const STATUS_INITIAL = 0
const STATUS_SAVING = 1
const STATUS_SUCCESS = 2
const STATUS_FAILED = 3

export default {
  name: 'Uploader',
  data() {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      warning: false
    }
  },
  props: {
    endpoint: {
      type: String,
      default: '',
      required: true
    },
    multiple: {
      type: Boolean,
      default: false,
      required: false
    },
    uploadFieldName: {
      type: String,
      default: 'file',
      required: false
    },
    required: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: 'image/*',
      required: false
    },
    hideTitle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED
    }
  },
  methods: {
    reset() {
      this.currentStatus = STATUS_INITIAL
      this.uploadedFiles = []
      this.uploadError = null
    },
    save(formData) {
      this.currentStatus = STATUS_SAVING

      this.$http.post(this.endpoint, formData)
        .then(response => {
          this.uploadedFiles = [].concat(response)
          this.currentStatus = STATUS_SUCCESS
          this.$emit('success', response.body)
        })
        .catch(err => {
          this.uploadError = err.response
          this.currentStatus = STATUS_FAILED
          this.$emit('error', err.response)
        })
    },
    filesChange(fieldName, fileList) {
      const formData = new FormData()

      if (!fileList.length) return

      Array
        .from(Array(fileList.length).keys())
        .map(x => {
          formData.append(fieldName, fileList[x], fileList[x].name)
        })
      this.$emit('changed', fileList)
      this.save(formData)
    }
  },
  mounted() {
    this.reset()
  }
}

</script>

<style lang="scss">
  .dropbox {
    outline: 2px dashed grey;
    outline-offset: -10px;
    background: lightcyan;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px;
    position: relative;
    cursor: pointer;
    &:hover {
      background: lightblue;
    }
    p {
      font-size: 1.2em;
      text-align: center;
      padding: 50px 0;
    }
  }
  .warning {
    background: lightsalmon;
    &:hover {
      background: lightpink;
    }
  }
  .input-file {
    opacity: 0;
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }
</style>
